import { render, staticRenderFns } from "./MainExplanation.vue?vue&type=template&id=e024929a"
import script from "./MainExplanation.vue?vue&type=script&lang=ts"
export * from "./MainExplanation.vue?vue&type=script&lang=ts"
import style0 from "./MainExplanation.vue?vue&type=style&index=0&id=e024929a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports